import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormArray, FormBuilder, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator, Validators } from '@angular/forms';
import { poolScheduleValidator } from 'components/drawers/add-pool-drawer/pool-schedule/pool-schedule.validator';
import { UTC_TIMES } from 'data/utc-times';
import moment from 'moment';
import { AddUTCToTimePipe } from 'pipes/add-utc-to-time.pipe';
import { SuppressErrorMatcher } from 'utils/error-matchers/suppress.error-matcher';

@Component({
  selector: 'app-alert-condition',
  standalone: false,
  templateUrl: './alert-condition.component.html',
  styleUrl: './alert-condition.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AlertConditionComponent),
      multi: true
     }
    ,{
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => AlertConditionComponent),
      multi: true
    }
  ]
})
export class AlertConditionComponent implements OnInit, ControlValueAccessor,Validator{
  @Input() underutilizationedit: any
  conscutive: any = [
    '1hours',
    '2hours',
    '3hours', '4hours', '5hours', '6hours', '7hours', '8hours', '9hours', '10hours', '11hours', '12hours', 'Custom'
  ]

  addtime: any = true;
  addPoolConsumptionSearch!: FormGroup;
  public suppressErrorState = new SuppressErrorMatcher();
  public utcStartTimes = [...UTC_TIMES];
  public utcEndTimes = [...UTC_TIMES];
  public currentdate: any
  public futuredate: any
  constructor(public fb: FormBuilder, private addUTCToTimePipe: AddUTCToTimePipe) { }

  value = 0;

  private onTouched = (value: any) => { };
  private onChanged = (value: any) => { };


  ngOnInit(): void {
   
 
    this.addPoolConsumptionSearch = this.fb.group({
      startTime: this.fb.array([this.getTimeData()]),
      allday: [false,Validators.required],
      percentage: ['', [Validators.required,
      Validators.pattern(/^(100|[1-9][0-9]?)$/)]],
      next: ['',Validators.required],
      day: ['',Validators.required],
      optionControl: ['0',Validators.required],
      Consecutive: ['',Validators.required],
      hours: ['',Validators.required]
    },
      {
        validators: [this.dayNextValidator]
      });


    this.addPoolConsumptionSearch.get('Consecutive')?.disable();
     this.addPoolConsumptionSearch.get('hours')?.disable()

    this.addPoolConsumptionSearch.valueChanges.subscribe((ele: any) => {
      this.onChanged({ 'after': ele, 'before': this.addPoolConsumptionSearch.getRawValue() })
    })
    this.addPoolConsumptionSearch.get('day')?.valueChanges.subscribe((ele: any) => {
      this.momentdate(ele, 'day')
    })
    this.addPoolConsumptionSearch.get('next')?.valueChanges.subscribe((ele: any) => {
      this.momentdate(ele, 'next')
    })
    


    this.addPoolConsumptionSearch.get('startTime')?.valueChanges.subscribe((ele: any) => {

      this.updaedTimeData(ele);
    })

  }
ngAfterViewInit(){
  this.addPoolConsumptionSearch.statusChanges.subscribe((ele:any)=>{
  
    
  })
 

  
}


validate(control: AbstractControl): ValidationErrors | null {
  return this.addPoolConsumptionSearch.valid ? null : {childformInvalid : true }
}

registerOnValidatorChange(fn: () => void): void {
  this.addPoolConsumptionSearch.statusChanges.subscribe(fn)
}

  writeValue(value: number): void {
  
    this.geteditutilization(value)
    this.value = value;
    
  }

  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setRating(rating: number) {
    this.value = rating;
    this.onChanged(rating);
    this.onTouched(rating);
  }

  getTimeData() {
    return this.fb.group({
      startTime: ['', [Validators.required,]],
      endTime: ['', [Validators.required,]],
    })
  }

  get FormDatasearchData() {
    return this.addPoolConsumptionSearch.get('startTime') as FormArray;
  }

  geteditutilization(value:any){

     if (value) {
      value.alertschdule?.perDay?.forEach((ele: any, index: any) => {
        this.FormDatasearchData.at(index).patchValue({ startTime: ele?.startTime, endTime: ele?.endTime })
        if (value.alertSchedule?.perDay.length - 1 > index) {
          this.Duplicatethedata()
        }
      })

      let splitdata = value.daystocheck
      let arraydata = splitdata.split("-")
     

      this.addPoolConsumptionSearch.get('next')?.patchValue(arraydata[0])
      this.addPoolConsumptionSearch.get('day')?.patchValue(arraydata[1])
      this.addPoolConsumptionSearch.get('percentage')?.patchValue(value.percentage)
      if (value.isHourly) {
        this.addPoolConsumptionSearch.get('Consecutive')?.enable()
        this.addPoolConsumptionSearch.get('optionControl')?.patchValue('1')
        this.addPoolConsumptionSearch.get('Consecutive')?.patchValue('2hours')

        this.addPoolConsumptionSearch.get('startTime')?.disable()
        // this.addPoolConsumptionSearch.get('allday')?.disable()
        this.addPoolConsumptionSearch.get('allday')?.setValue(false)
        this.FormDatasearchData.at(0).reset()

      }
      if (value.alertschdule.isAllDay) {
        this.addPoolConsumptionSearch.get('allday')?.patchValue(value.alertschdule.isAllDay);
        this.addPoolConsumptionSearch.get('optionControl')?.patchValue('0');
        this.addPoolConsumptionSearch.get('startTime')?.disable()
        this.addtime = false;
        this.addPoolConsumptionSearch.get('Consecutive')?.disable()
        this.addPoolConsumptionSearch.get('hours')?.disable()
        this.addPoolConsumptionSearch.get('Consecutive')?.reset()
      }





    }
  }

  Duplicatethedata() {
    return this.FormDatasearchData.push(this.getTimeData());
  }

  removedatafromSearchPool(i: number) {
    if (this.FormDatasearchData.length > 1) {
      this.FormDatasearchData.removeAt(i);
    }
    else {
      const getThresholditemslist = this.FormDatasearchData.at(0);
      getThresholditemslist?.reset();
    }
  }

  get registerFormControl() {
    return this.addPoolConsumptionSearch.controls;
  }

  getValidationcontrols(index: any) {
    let getFormArray = this.addPoolConsumptionSearch.get('startTime') as FormArray;
    const updateformGroup = getFormArray.controls[index] as FormGroup;
    return updateformGroup;
  }
  public addUTCToTime(time: string): string {
    return this.addUTCToTimePipe.transform(time);
  }

  selecteddata(event: any) {

    if (event.value == 1) {
      this.addPoolConsumptionSearch.get('Consecutive')?.enable()
      this.addPoolConsumptionSearch.get('startTime')?.disable()
      this.addPoolConsumptionSearch.get('hours')?.enable()
      this.addPoolConsumptionSearch.get('allday')?.setValue(false)
      this.FormDatasearchData.at(0).reset()


    }
    else {
      this.addPoolConsumptionSearch.get('Consecutive')?.disable()
      this.addPoolConsumptionSearch.get('hours')?.disable()
      this.addtime = true;
      this.addPoolConsumptionSearch.get('startTime')?.enable()
      this.addPoolConsumptionSearch.get('allday')?.enable()
      this.addPoolConsumptionSearch.get('allday')?.setValue(false)
      this.addPoolConsumptionSearch.get('Consecutive')?.reset();
      this.FormDatasearchData.at(0).reset()

    }

  }

  checkstatusallday(event: any) {

    if (event.checked) {
      this.addPoolConsumptionSearch.get('optionControl')?.patchValue('0');
      this.addtime = false;
      this.addPoolConsumptionSearch.get('Consecutive')?.disable()
      this.addPoolConsumptionSearch.get('Consecutive')?.reset()
      this.FormDatasearchData.at(0).reset()
      let setstartvalue = this.FormDatasearchData.at(0)
      setstartvalue.patchValue({
        startTime: "00:00",
        endTime: "23:45",
      })
      setstartvalue.disable()

    } else {

      this.FormDatasearchData.at(0).reset()
      this.addPoolConsumptionSearch.get('startTime')?.enable()
    }

  }

  momentdate(ele: any, value: any) {
    if (value == 'day') {

      const futureDate = moment().add(ele, 'days');
      this.currentdate = futureDate.format('MMMM D, YYYY');
    } else {
      const todaydate = moment().add(ele, 'days')
      this.futuredate = todaydate.format('MMMM D, YYYY');
    }


    // this.currentdate=futureDate.format('YYYY-MM-DD');
    // this.futuredate=todaydate.format('YYYY-MM-DD');

  }

  updaedTimeData(event: any) {
    const uniqueObjects = [];
    const seenStarts = new Set();
    for (const [index, obj] of event.entries()) {
      if (!obj || obj.startTime === null || obj.endTime === null || obj.startTime === "" || obj.endTime === "") {
      } else {
        if (obj.startTime >= obj.endTime) {
          const getsearchFromControls = this.FormDatasearchData.at(index);
          getsearchFromControls.get('startTime')?.setValue('');
          getsearchFromControls.get('endTime')?.setValue('');
          continue;
        }
        if (seenStarts.has(obj.startTime)) {
          const getsearchFromControls = this.FormDatasearchData.at(index);
          getsearchFromControls.get('startTime')?.setValue('');
          getsearchFromControls.get('endTime')?.setValue('');
          continue;
        }
        seenStarts.add(obj.startTime);
        uniqueObjects.push(obj);
      }
    }
  }

  dayNextValidator(group: AbstractControl) {
    const next = Number(group.get('next')?.value);
    const day = Number(group.get('day')?.value);
    


    if (isNaN(next) || isNaN(day)) {
      return null;
    }

    // negative check
    // if (next < 0 || day < 0) {
    //   return { negativeValue: true };
    // }

    // main rule: next should NOT be greater than day
    if (next > day) {
      return { invalidRange: true };
    }

    return null;
  }

  onlyNumberKey(event: KeyboardEvent) {
    const charCode = event.key;

    if (!/^[0-9]$/.test(charCode)) {
      event.preventDefault();
    }
  }

  isformDirty() {
    let control1;
    let controol2;

    const lasttime = this.FormDatasearchData.at(this.FormDatasearchData.length - 1);
    control1 = lasttime.get('startTime')?.dirty;
    controol2 = lasttime.get('endTime')?.dirty;

    if (control1 && controol2) {
      return false;
    } else {
      return true;
    }
  }
}
